import { Injectable, Injector } from '@angular/core';

import { FootprintEdi_FrontendFlowService } from './FootprintEdi.frontend.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FrontendFlowService {

  constructor(
    public FootprintEdi: FootprintEdi_FrontendFlowService,
    private injector: Injector
  ) {
  }

  public app: app_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
